import { FC, useEffect, useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { Project } from '@/utils/types';
import { motion } from 'motion/react';

type Props = {
  project: Project;
  className?: string;
};

export const ProjectCard: FC<Props> = ({ project, className = '' }) => {
  const [projectData, setProjectData] = useState(project);

  useEffect(() => {
    setProjectData(project);
  }, [project]);

  const { id, slug, title, intro, services, featuredImage } = projectData;

  let widthClass;

  //const wideImageItems = [3, 6, 11, 16];
  widthClass = 'col-span-4 row-span-1 sm:col-span-2 lg:row-span-2';

  // widthClassOld = wideImageItems.includes(id)
  // 	? "col-span-4 row-span-1 sm:col-span-2 lg:row-span-2"
  // 	: "col-span-4 sm:col-span-2 lg:col-span-1";

  return (
    <motion.article
      className={`group overflow-hidden ${widthClass} ${className}`}
      key={id}
      initial="initial"
      whileHover="hover">
      <Link
        href={`/work/${slug}`}
        passHref
        className="group flex w-full cursor-pointer flex-col transition-all md:h-full">
        <div className="overflow-hidden rounded-lg transition-all duration-500">
          <Image
            src={featuredImage.src}
            alt={featuredImage.alt ? featuredImage.alt : title}
            width="0"
            height="0"
            sizes="100vw"
            className="w-full grow origin-center object-cover transition-all duration-500 group-hover:scale-102"
          />
        </div>

        <div className="pt-4 pb-2">
          {/* <div className="inline-block">
            <StaggeredText
              text={title}
              duration={0.15}
              className="inline-flex text-2xl leading-6 font-light lg:text-3xl"></StaggeredText>
            
            <div className="group-hover:bg-primary-500 z-0 mt-0.5 block h-0.5 w-0 transition-all duration-500 ease-out group-hover:w-full" />
          </div> */}
          <h3 className="inline-flex text-2xl leading-6 font-light lg:text-3xl">
            {title}
          </h3>
          {intro && <p className="pt-0.5 opacity-60">{intro}</p>}

          {/* services v1 */}
          {/* <ul className="text-dark/60 dark:text-ivory/60 mt-4 flex flex-wrap text-sm font-normal">
            {(services ?? []).map((service, index, arr) => {
              return (
                <li key={index} className="">
                  {service}

                  {index === arr.length - 1 ? (
                    ''
                  ) : (
                    <span className="pr-1">, </span>
                  )}
                </li>
              );
            })}
          </ul> */}

          <motion.ul className="text-dark/60 dark:text-ivory/60 mt-2 flex flex-wrap gap-2 lg:text-lg">
            {(services ?? []).map((service, index) => {
              return (
                <motion.li
                  key={index}
                  custom={index}
                  variants={{
                    initial: { y: -24, opacity: 0 },
                    hover: (i: number) => ({
                      y: 0,
                      opacity: 1,
                      transition: {
                        delay: i * 0.05, // stagger effect
                        duration: 0.3,
                        ease: 'easeInOut',
                      },
                    }),
                  }}
                  className="bg-cream-dark dark:text-ivory/60 dark:bg-dark-lighten rounded-full px-1.5 py-0.5 text-sm">
                  {service}
                </motion.li>
              );
            })}
          </motion.ul>
        </div>
      </Link>
    </motion.article>
  );
};
